import { ProductCategory } from './actions';
import { ProductState } from './reducer';

const selectSlice = (state: any): ProductState => state.CategoryManager;

export const getProductList = (state: any): ProductCategory[] =>
  selectSlice(state)?.list ?? [];

export const getProductLoading = (state: any): boolean =>
  !!selectSlice(state)?.loading;

export const getProductSaving = (state: any): boolean =>
  !!selectSlice(state)?.saving;

export const getProductError = (state: any): string | undefined =>
  selectSlice(state)?.error;

export const getFilterName = (state: any): string =>
  selectSlice(state)?.filterName ?? '';

export const getModalOpen = (state: any): boolean =>
  !!selectSlice(state)?.modalOpen;

export const getEditingItem = (state: any): ProductCategory | null =>
  selectSlice(state)?.editing ?? null;
